import React from "react";
import styled from "styled-components";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepSelectPlanPrepaid from "components/Step/StepSelectPlanPrepaid";
import GuidedSignUpFaq from "components/GuidedSignUp/GuidedSignUpFaq";
import { GuidedSignUpCollapsibleClassName } from "components/GuidedSignUp/GuidedSignUpCollapsible";

const StyledGuidedSignUpFaq = styled(GuidedSignUpFaq)`
  max-width: 335px;

  .${GuidedSignUpCollapsibleClassName.CHILDREN} {
    padding-right: 2rem;
  }
`;

export const MembershipStepSelectPlanPrepaid = ({
  routePrevStep,
  ...state
}: MembershipState) => {
  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepSelectPlanPrepaid
      appendedContent={
        <StyledGuidedSignUpFaq
          bgColor="transparent"
          questionAnswers={[
            {
              question: "How does the 30 day guarantee work?",
              answer:
                "If you’re not fully satisfied, reach out within the first 30 days and we will refund your membership. If you have books at home from the box, we kindly ask you to return them to us and only pay the return shipping cost. You will also have the option to purchase any that you’d like to keep at a discount.",
            },
            {
              question: "How do you pick books for my reader?",
              answer:
                "We start with their age and reading level to choose books that are just right. Then we factor in topics they like, new genres for them to explore, and which types of books they’ve received so far. Rating books in the app helps us understand what your reader loves!",
            },
            {
              question: "How can I adjust my schedule?",
              answer:
                "In your account management page, you can adjust your delivery schedule. You can choose whether to receive a box every month or every couple of months. Going on holiday? No worries: you can also easily choose to delay box shipments by one week or up to a month.",
            },
          ]}
        />
      }
      stepFooterProps={{
        backButtonProps,
      }}
      stepHeaderProps={{
        backButtonProps,
      }}
      {...state}
    />
  );
};

export const MEMBERSHIP_STEP_SELECT_PLAN_PREPAID: MembershipStep = {
  component: MembershipStepSelectPlanPrepaid,
  id: "membership-id-select-plan-prepaid",
  slug: "plan",
};

export default MEMBERSHIP_STEP_SELECT_PLAN_PREPAID;
